/** The texts of the inference service for partner sites (INF-*), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const inferenceEn = {
  inference: 'Inference',
  inferenceIntro: "The site's systems send radiographs to the released models and get findings back, for research only. The platform keeps only counts of use.",
  inferenceNoAccess: 'The site has no access to the inference service. A platform admin grants it.',
  inferenceUntil: 'Access until {date}',
  inferenceDailyLimit: 'at most {count} images a day',
  inferenceEnded: 'Access ended',
  inferenceGrant: 'Grant access',
  inferenceValidUntil: 'Valid until',
  inferenceLimitLabel: 'Images per day (empty: no limit)',
  inferenceDay: 'Day',
  inferenceModel: 'Model',
  inferenceKeyRevoked: 'Revoked',
  inferenceWithdraw: 'Withdraw access now',
  inferenceContribution: 'Contribution: {images} accepted images, {readings} finished readings',
  inferenceTerms: 'Inference terms',
  inferenceTermsPending: 'A site admin accepts the inference terms before the site’s systems may send.',
  inferenceAccept: 'Accept for the site',
  inferenceKeys: 'Keys of the site’s systems',
  inferenceKeyName: 'System',
  inferenceKeyExpires: 'Expires on',
  inferenceKeyNetworks: 'Only from networks',
  inferenceKeyNetworksHint: 'Address ranges such as 10.20.0.0/16, separated by commas; empty: from anywhere.',
  inferenceKeyCreate: 'Create key',
  inferenceKeyShownOnce: 'Copy the key now: it is shown only this once.',
  inferenceKeyLastUsed: 'last used {date}',
  inferenceKeyNeverUsed: 'not used yet',
  inferenceUse: 'Use in the last 30 days',
  inferenceImages: 'Images',
  inferenceToday: 'Today',
  inferenceNoUse: 'No site used the inference service in the last 30 days.',
  inferenceRejected: 'Refused',
  inferenceErrors: 'Errors',
  inferenceModels: 'Released models',
  inferenceAvailableUntil: 'available until {date}',
  inferenceRelease: 'Inference service',
  inferenceReleased: 'Released',
  inferenceReleaseCard: 'Model card',
  inferenceReleaseSave: 'Release with this card',
  inferenceReleaseWithdraw: 'End the release',
}

export const inferenceDe: Record<keyof typeof inferenceEn, string> = {
  inference: 'Inferenz',
  inferenceIntro: 'Die Systeme des Standorts senden Röntgenbilder an die freigegebenen Modelle und erhalten Befunde, nur zur Forschung. Die Plattform behält nur Zählungen der Nutzung.',
  inferenceNoAccess: 'Der Standort hat keinen Zugang zum Inferenzdienst. Eine Plattformadministration gewährt ihn.',
  inferenceUntil: 'Zugang bis {date}',
  inferenceDailyLimit: 'höchstens {count} Bilder pro Tag',
  inferenceEnded: 'Zugang beendet',
  inferenceGrant: 'Zugang gewähren',
  inferenceValidUntil: 'Gültig bis',
  inferenceLimitLabel: 'Bilder pro Tag (leer: ohne Grenze)',
  inferenceDay: 'Tag',
  inferenceModel: 'Modell',
  inferenceKeyRevoked: 'Widerrufen',
  inferenceWithdraw: 'Zugang sofort entziehen',
  inferenceContribution: 'Beitrag: {images} angenommene Bilder, {readings} abgeschlossene Befundungen',
  inferenceTerms: 'Nutzungsbedingungen der Inferenz',
  inferenceTermsPending: 'Eine Standortadministration akzeptiert die Nutzungsbedingungen, bevor die Systeme des Standorts senden dürfen.',
  inferenceAccept: 'Für den Standort akzeptieren',
  inferenceKeys: 'Schlüssel der Systeme des Standorts',
  inferenceKeyName: 'System',
  inferenceKeyExpires: 'Läuft ab am',
  inferenceKeyNetworks: 'Nur aus Netzen',
  inferenceKeyNetworksHint: 'Adressbereiche wie 10.20.0.0/16, durch Kommas getrennt; leer: von überall.',
  inferenceKeyCreate: 'Schlüssel erzeugen',
  inferenceKeyShownOnce: 'Kopieren Sie den Schlüssel jetzt: Er wird nur dieses eine Mal angezeigt.',
  inferenceKeyLastUsed: 'zuletzt genutzt am {date}',
  inferenceKeyNeverUsed: 'noch nicht genutzt',
  inferenceUse: 'Nutzung der letzten 30 Tage',
  inferenceImages: 'Bilder',
  inferenceToday: 'Heute',
  inferenceNoUse: 'Kein Standort hat den Inferenzdienst in den letzten 30 Tagen genutzt.',
  inferenceRejected: 'Abgelehnt',
  inferenceErrors: 'Fehler',
  inferenceModels: 'Freigegebene Modelle',
  inferenceAvailableUntil: 'verfügbar bis {date}',
  inferenceRelease: 'Inferenzdienst',
  inferenceReleased: 'Freigegeben',
  inferenceReleaseCard: 'Modellkarte',
  inferenceReleaseSave: 'Mit dieser Karte freigeben',
  inferenceReleaseWithdraw: 'Freigabe beenden',
}
